import React, { useEffect, useState } from "react";
import SuperUserHeader from "../../components/SuperUserHeader";
import SuperUserSideMenu from "../../components/SuperUserSideMenu";
import UserList from "./components/UserList";
import TextInput from "../../components/TextInput";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import {
    setSearchQuery,
    getSuperUserList,
    setCurrentPage,
    setIsSearch,
} from "../../reducers/superUser";
import {trimStringFields} from "utils/format";

const SuperUser = () => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const {
        currentPage,
        userList,
        pageSize,
        sortBy,
        sortOrder,
        searchQuery,
        error,
    } = useSelector((state: any) => state.superUser);

    const fetchUserList = (page = currentPage, search=searchQuery) => {
        let data = {
            searchQuery: search,
            page: page,
            pageSize: pageSize,
            sortBy: sortBy,
            sortOrder: sortOrder,
        }
        data = trimStringFields(data);
        dispatch(getSuperUserList(data));
        dispatch(setCurrentPage(page));
    }

    useEffect(() => {
        fetchUserList();
    }, [sortBy, sortOrder, currentPage, pageSize]);

    const handleSearchUser = (event: any) => {
        if (event.key === "Enter") {
            fetchUserList(1);
            if(searchQuery) dispatch(setIsSearch(true));
            else dispatch(setIsSearch(false));
        }
    };

    const handleSetSearchQuery = (value: string) => {
        dispatch(setSearchQuery(value));
    };

    const handleClearSearch = () => {
        handleSetSearchQuery("");
        fetchUserList(1, "");
    }
    
    return (
        <div className="bg-alu-base h-dvh">
        <SuperUserHeader />
        <div className="mt-6 px-6 flex gap-6 relative">
            <SuperUserSideMenu />
            <div className="flex-1">
                <div className="flex items-center justify-between">
                    <h1 className="text-xl font-bold leading-[1.875rem] alu-text-base-2 pl-4">
                        スーパーユーザー
                    </h1>
                    <TextInput
                        name="search"
                        value={searchQuery}
                        onChange={(e: any) => handleSetSearchQuery(e.target.value)}
                        onClearQuery={() => handleClearSearch()}
                        onKeyDown={(e: any) => handleSearchUser(e)}
                        placeholder="検索"
                        searchIcon={true}
                    />
                </div>
                <div className="mt-6">
                    <UserList userList={userList} />
                </div>
            </div>
        </div>
        </div>
    );
};

export default SuperUser;
